import { PromoCheckoutRoute } from './-components';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/checkout')({
  component: PromoCheckoutRoute,
});
